export default {
  default: {
    cognito: {
      userPoolProviderUrl: 'https://cognito-idp.us-east-1.amazonaws.com/us-east-1_oIbMI9cct'
    },
    pactsafe: {
      accessId: 'fa7d0a93-14cb-4133-9844-c97bf949ee55',
      termsOfService: {
        groupKey: 'group-hjzie-ks9'
      }
    }
  },
  prod: {
    cognito: {
      userPoolProviderUrl: 'https://cognito-idp.us-east-1.amazonaws.com/us-east-1_jZ8z0v67T'
    },
    pactsafe: {
      accessId: 'c6191a12-feee-465b-aad6-03f481637113',
      termsOfService: {
        groupKey: 'group-bjffmqur5'
      }
    }
  }
}
